/****************
* 本地缓存方法
* 封装sessionStorage -- 一般是用这个
* 封装localStorage
****************/

const ss = window.sessionStorage
const ls = window.localStorage

export default {
  /*------------- sessionStorage 操作 start -------------*/
  /*-------------- sessionStorage - 针对一个 session 的数据存储 */
    // 获取
    s_getItem(key) {
      try {
        return JSON.parse(ss.getItem(key))
      } catch (err) {
        return null
      }
    },

    // 设置
    s_setItem(key, val) {
      ss.setItem(key, JSON.stringify(val))
    },

    // 清空所有
    s_clear() {
      ss.clear()
    },

    s_keys() {
      return ss.keys()
    },

    // 删除
    s_removeItem(key) {
      ss.removeItem(key)
    },


     //存储,可设置过期时间
        s_set(key, value, expires) {
            let params = { key, value, expires };
            if (expires) {
                // 记录何时将值存入缓存，毫秒级
                var data = Object.assign(params, { startTime: new Date().getTime() });
                ss.setItem(key, JSON.stringify(data));
            } else {
                if (Object.prototype.toString.call(value) == '[object Object]') {
                    value = JSON.stringify(value);
                }
                if (Object.prototype.toString.call(value) == '[object Array]') {
                    value = JSON.stringify(value);
                }
                ss.setItem(key, value);
            }
        },
        //取出
        s_get(key) {
            let item = ss.getItem(key);
            // 先将拿到的试着进行json转为对象的形式
            try {
                item = JSON.parse(item);
            } catch (error) {
                // eslint-disable-next-line no-self-assign
                item = item;
            }
            // 如果有startTime的值，说明设置了失效时间
            if (item && item.startTime) {
                let date = new Date().getTime();
                // 如果大于就是过期了，如果小于或等于就还没过期
                if (date - item.startTime > item.expires) {
                    ss.removeItem(name);
                    return false;
                } else {
                    return item.value;
                }
            } else {
                return item;
            }
        },




  /*------------- sessionStorage 操作 start -------------*/









  /*------------- localStorage 操作 start -------------*/
    // 获取
    l_getItem(key) {
      try {
        return JSON.parse(ls.getItem(key))
      } catch (err) {
        return null
      }
    },

    // 设置
    l_setItem(key, val) {
      ls.setItem(key, JSON.stringify(val))
    },

    // 清空所有
    l_clear() {
      ls.clear()
    },

    l_keys() {
      return ls.keys()
    },

    // 删除
    l_removeItem(key) {
      ls.removeItem(key)
    }
    /*------------- localStorage 操作 end -------------*/
}



// WEBPACK FOOTER //
// ./src/components/libs/storage.js